import showJSDConfirmPayDialog from '@/components/jsdConfirm/jsdConfirmPayDialog';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  apiBalanceRecharge,
  apiGetBalance,
  apiGetBalanceRechargePayInfo,
  apiGetDirectRechargeList,
  apiGetPayTypeConfigList,
  apiGetUserInfo,
  apiGetWeChatSignature,
} from '../../api';
import AppBar from '../../components/appBar';
import Page from '../../components/page';
import RadioBox from '../../components/radioBox';
import main from '../../main';
import { PayType } from '../../utils/dict';
import showPayPage from '../../utils/pay';
import { LoadingMask, formatNumber, modelParsePrice, showConfirm, showToast } from '../../utils/utils';

export default function BalanceRechargePage() {
  const navigate = useNavigate();

  // 充值优惠信息
  // const [reduction, setReduction] = useState<any>({});
  // 充值面值列表
  const [preMoneyList, setPreMoneyList] = useState<DirectRecharge[]>([]);
  // 已选充值面值
  const [preMoney, setPreMoney] = useState<DirectRecharge>();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id'); // 例如：URL?param1=value1
  // 支付方式列表
  const [payConfigList, setPayConfigList] = useState<PayTypeConfig[]>([]);
  // 已选支付方式
  const [payType, setPayType] = useState<string>();
  const [wxReady, setWxReady] = useState(false);
  // 停留或后退计时
  const backRef = useRef<{ timer?: NodeJS.Timeout; time: number; isShow: boolean }>({ time: 0, isShow: false });
  const [submitFlag, setsubmitFlag] = useState<boolean>(false);

  useEffect(() => {
    let _backRef = backRef.current;
    loadBalance();
    loadDirectRechargeList();
    wxConfig();
    // loadPayConfigReduction();
    // @ts-ignore
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener(
          'WeixinJSBridgeReady',
          () => {
            setWxReady(true);
          },
          false
        );
        // @ts-ignore
      } else if (document.attachEvent) {
        // @ts-ignore
        document.attachEvent('WeixinJSBridgeReady', () => {
          setWxReady(true);
        });
      }
    } else {
      setWxReady(true);
    }
    startBackTimer();
    return () => {
      if (_backRef.timer) {
        clearInterval(_backRef.timer);
      }
    };
  }, []); // eslint-disable-line

  /**
   * 获取余额
   */
  async function loadBalance() {
    try {
      var res = await apiGetBalance(main.currentEm?.id!);
      var data = res.data;
      if (data.code === 200) {
        await loadPayConfigList(data?.data?.payType);
      }
    } catch (e) {}
  }
  function startBackTimer() {
    if (!backRef.current.timer) {
      backRef.current.timer = setInterval(() => {
        backRef.current.time++;
        if (backRef.current.time >= 60) {
          backRef.current.isShow = true;
          handleLongTimeDialog();
        }
        if (backRef.current.isShow) {
          clearInterval(backRef.current.timer);
        }
      }, 1000);
    }
  }

  async function handleBack() {
    if (backRef.current.isShow) {
      navigate(-1);
    } else {
      let res = await showConfirm({
        title: '提示',
        content: '您是否存在疑问，需要联系客服？',
        cancelBtnText: '返回',
        confirmBtnText: '联系客服',
      });
      if (res === 1) {
        navigate('/customer');
      } else {
        navigate(-1);
      }
    }
  }

  async function handleLongTimeDialog() {
    let res = await showConfirm({
      title: '提示',
      content: '您在该界面停留时间过久，是否存在疑问？',
      hideCancelBtn: true,
      confirmBtnText: '联系客服',
    });
    if (res === 1) {
      navigate('/customer');
    }
  }
  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;

    let res = await apiGetWeChatSignature(
      main.isIos14 && !!main.enterUrl ? main.enterUrl : window.location.href.split('#')[0],
      main.appId
    );
    let data = res.data;
    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'],
      });
    }
  }

  /**
   * 获取支付配置列表
   */
  async function loadPayConfigList(_payType: string) {
    try {
      let res = await apiGetPayTypeConfigList();
      let data = res.data;
      if (data.code === 200) {
        let list: PayTypeConfig[] = data.data ?? [];
        list = list.filter((i) => i.payType !== PayType.balance);
        setPayConfigList(list);
        if (_payType !== PayType.userSelected) {
          let defaultSelectedItem = (list ?? []).filter((i: PayTypeConfig) => i?.defaultSelected === 'Y');
          setPayType(!!defaultSelectedItem ? defaultSelectedItem[0]?.payType! : '');
        }
        // let payTypes = list.map((i: PayTypeConfig) => i.payType!);
        // if (payTypes.length && !payType) {
        //   setPayType(payTypes[0]);
        // }
      }
    } catch (e) {}
  }
  console.log('submitFlag', submitFlag);

  async function loadDirectRechargeList() {
    try {
      let res = await apiGetDirectRechargeList(main.currentEm!.id!);
      let data = res.data;
      if (data.code === 200) {
        let _list = data.data ?? [];
        setPreMoneyList(data.data ?? []);
        if (_list!.length && !preMoney) {
          if (id) {
            const _preMoney = _list!.find((item: any) => item.payDetailId === id);
            setPreMoney(_preMoney);
          } else {
            setPreMoney(_list[0]);
          }
        }
      }
    } catch (e: any) {}
  }

  // /**
  //  * 获取支付优惠
  //  */
  // async function loadPayConfigReduction() {
  //   try {
  //     let res = await apiGetPayConfigReduction(main.currentEm?.id!);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       let _map: any = {};
  //       (data.data ?? []).forEach((i: any) => (_map[i.payType] = i));
  //       setReduction(_map);
  //     }
  //   } catch (e) {}
  // }

  async function handleRecharge() {
    if (submitFlag) return;
    if (!main.openId && !main.isDev) {
      return showToast('授权失败,请在微信内打开');
    }
    if (!main.currentEm?.id) {
      return showToast('请选择卡号');
    }
    if (!payType) {
      return showToast('请选择支付方式');
    }
    if (!preMoney) {
      return showToast('请选择充值金额');
    }
    setsubmitFlag(true);
    LoadingMask.show('正在充值...');
    try {
      let res = await apiBalanceRecharge(main.currentEm.id, preMoney.payDetailId!, main.appId, main.openId!);
      let data = res.data;
      if (data.code === 200) {
        let _data = data.data;
        let orderId = _data.orderId;
        let payInfo = await apiGetBalanceRechargePayInfo(orderId, payType, main.openId!);
        let payInfoData = payInfo.data;
        if (payInfoData.code === 200) {
          let _data = payInfoData.data;
          if (
            payType === PayType.aliPage ||
            payType === PayType.jsd_h5_ali ||
            payType === PayType.lkl_ali_pay ||
            payType === PayType.yh_wx_web ||
            payType === PayType.yh_ali_web
          ) {
            let payRes = await showPayPage(_data, payType);
            if (payRes.code === 300 || payRes.code === 400) {
              if (payRes.url) {
                LoadingMask.hide();
                window.location.href = payRes.url;
                await showConfirm({
                  title: '提示',
                  content: '是否支付完成?',
                  confirmBtnText: '支付完成',
                  cancelBtnText: '未完成',
                });
                navigate('/home', { replace: true });
                showToast('支付成功');
              }
              showToast(payRes.msg);
            } else if (payRes.code === 500) {
              showToast(payRes.msg);
            } else {
              showToast('数据还在准备,请稍后重试');
            }
          } else if (payType === PayType.jsd_mini_wx) {
            // 金舜达 银盛支付 小程序支付  需要弹窗让用户再次点击按钮
            LoadingMask.hide();
            let res = await showJSDConfirmPayDialog({
              miniOrgId: _data.miniOrgId,
              miniPath: _data.miniPath,
              miliPaLink: _data.miniPayLink,
            });
            if (res === 2) {
              showToast('小程序跳转失败');
            } else if (res === 1) {
              let payRes = await showConfirm({
                title: '提示',
                content: '是否支付完成?',
                confirmBtnText: '支付完成',
                cancelBtnText: '未完成',
              });
              if (!payRes) return;
              navigate('/home', { replace: true });
            } else {
              showToast('取消支付');
            }
          } else {
            if (wxReady) {
              let payRes = await showPayPage(_data, payType);
              if (payRes.code === 200) {
                navigate(-1);
                showToast('支付成功');
                try {
                  let res = await apiGetUserInfo(main.loginKey!);
                  let data = res.data;
                  if (data.code === 200) {
                    main.user = data.data.user;
                  }
                } catch (e: any) {
                  console.error(e);
                }
              } else if (payRes.code === 300) {
                if (payRes.url) {
                  LoadingMask.hide();
                  navigate('/iframe', { state: { url: payRes.url, title: '银联支付', pay: true, back: true } });
                }
              } else if (payRes.code === 400 && !!payRes.url) {
                LoadingMask.hide();
                window.location.href = payRes.url!;
                // let isPayRes = await showConfirm({
                //   title: '提示',
                //   content: '是否支付完成?',
                //   confirmBtnText: '支付完成',
                //   cancelBtnText: '未完成',
                // });
                // if (!isPayRes) return;
                // navigate('/home', { replace: true });
              } else {
                showToast('支付失败');
              }
            } else {
              showToast('数据还在准备,请稍后重试');
            }
          }
        } else {
          showToast(payInfoData.msg ?? '支付失败');
        }
      } else if (data.code === 505) {
        let resMsg = await showConfirm({
          title: '温馨提示',
          content: '检测到您多次未完成支付，请确认订购意向后再进行缴费！',
          confirmBtnText: '联系客服',
          cancelBtnText: '关闭',
        });
        if (!resMsg) return;
        navigate('/customer');
      } else {
        showToast(data.msg ?? '支付失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '支付失败');
    } finally {
      setsubmitFlag(false);
      LoadingMask.hide();
    }
  }

  var textStrs: string[] = [];
  if (modelParsePrice(preMoney?.price ?? 0) > modelParsePrice(preMoney?.amount ?? 0)) {
    textStrs.push(
      `充${formatNumber(preMoney!.amount!)}元得${formatNumber(
        Number(preMoney!.price!) + Number(preMoney!.activityAmount ?? 0)
      )}元(立即到账)`
    );
  }

  if (preMoney?.coupons) {
    for (var i of preMoney!.coupons) {
      textStrs.push(`送${i.couponName} X${formatNumber(i.couponNum ?? 0)}张`);
    }
  }

  let itemList: ReactNode[] = preMoneyList.map((item) => {
    // 到账金额
    let getAmount = Number(item.price ?? 0) + Number(item.activityAmount ?? 0);
    // 赠送金额
    let giveAmount =
      Number(item.price ?? 0) >= Number(item.amount ?? 0)
        ? Number(item.activityAmount ?? 0) + Number(item.price ?? 0) - Number(item.amount ?? 0)
        : 0;
    // 充值金额
    let rechargeAmount = Number(item.amount ?? 0);
    return (
      <div
        className={`d-flex-c ai-center jc-center w-150 mb-20 h-70 mr-10 bg-gray pos-r border ${
          item.payDetailId === preMoney?.payDetailId ? ' border-color-origin-red bg-origin-red-t' : ''
        } border-radius-8`}
        key={item.payDetailId}
        onClick={() => setPreMoney(item)}
      >
        {/* 充 amount 得 price */}
        <div className=" text-color-origin-red">
          <span>到账</span>
          <span className="font-size-18">{formatNumber(getAmount)}</span>元
        </div>
        {getAmount > 0 && <div className="font-size-12 mt-3">赠送{formatNumber(giveAmount)}</div>}
        <div className="mt-3">售价:{formatNumber(rechargeAmount)}元</div>
        {modelParsePrice(item?.price ?? 0) > modelParsePrice(item?.amount ?? 0) && (
          <img src="/pic/icon_preferential.png" className="icon-30 pos-a r-0 t-0" alt="" />
        )}
      </div>
    );
  });
  if (textStrs.length > 0) {
    let idx = preMoneyList.findIndex((item) => item.payDetailId === preMoney?.payDetailId);
    let curr = preMoneyList[idx];
    let descView = (
      <div className="w-335 h-70 pos-r mb-20">
        <img className="bw-100 h-70 pos-a l-0 t-0" src="/pic/icon_recharge_desc_bg.png" alt="" />
        <div className="pos-r d-flex-r bw-100 bh-100">
          <div className="w-100 d-flex-c ai-center jc-center">
            <div className="text-color-origin-red">
              <span className="font-size-20">{curr?.price}</span>元
            </div>
            <div>价值</div>
          </div>
          <div className="flex-1 d-flex-c ai-start jc-center pl-10 mr-10">
            {textStrs.map((i, idx) => (
              <div key={idx}>
                {idx + 1}、{i}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
    itemList.splice((Math.floor(idx / 2) + 1) * 2, 0, descView);
  }
  return (
    <Page
      className="d-flex-c"
      contentClassName="flex-1 d-flex-c ai-start h-1 p-20 overflow-y pos-r"
      appBar={<AppBar title="余额充值" onBack={handleBack} />}
    >
      <div className="d-shadow-p border-radius-40 pos-r bw-100">
        <img className="bw-100 bh-100 pos-a l-0 t-0 border-radius-20" src="/pic/icon_recharge_card.png" alt="" />
        <div className="pos-r p-20 bw-100 bh-100 d-flex-c text-color-white">
          <div className="font-size-12 mb-20">设备号：{main.currentEm?.emNumber}</div>
          <div className="font-size-48 d-flex-r ai-start jc-center">
            {formatNumber(
              Number(main.currentEm!.cardDetailWalletVo?.availableAmount ?? 0) +
                Number(main.currentEm!.cardDetailWalletVo?.activityAmount ?? 0)
            )}
            <img
              className="icon-18 mt-8 ml-5"
              src="/pic/icon_question_circle.png"
              alt=""
              onClick={() => {
                showConfirm({
                  title: '账户金额',
                  hideCancelBtn: true,
                  confirmBtnText: '关闭',
                  content: (
                    <div>
                      <div>余额:{Number(main.currentEm!.cardDetailWalletVo?.availableAmount ?? 0).toString()}</div>
                      <div>活动金:{Number(main.currentEm!.cardDetailWalletVo?.activityAmount ?? 0).toString()}</div>
                    </div>
                  ),
                });
              }}
            />
          </div>
          <div className="font-size-12 text-center">账户金额(元)</div>
        </div>
      </div>
      <div className="mb-20 mt-20 font-size-16">充值金额</div>
      <div className="d-flex-r flex-wrap jc-between">{itemList}</div>
      <div className="text-color-9 font-size-12">
        {!!textStrs.length && <div className="font-size-12">*参与规则</div>}

        {!!textStrs.length && <div>1、流量券需要主动使用,使用后在当月内生效;</div>}
        {!!textStrs.length && (
          <div className="font-size-12 font-color-9">2、抵扣券在购买套餐时主动选择,可抵扣相应金额;</div>
        )}
        {!!textStrs.length && (
          <div className="font-size-12 font-color-9 mb-10">3、赠送抵扣券只能用来购买基础套餐使用;</div>
        )}
      </div>

      <div className="mt-20 font-size-16">支付方式</div>
      {payConfigList.map((item, idx) => {
        return (
          <div key={idx} className="mt-20 bw-100 d-flex-r jc-between ai-center pr-60" onClick={() => setPayType(item.payType)}>
            <div className="d-flex-r ai-center">
              <img className="w-20 mr-10" src={`/pic/${PayType.typeIcon(item.payType)}`} alt="" />
              <span>{item.name}</span>
            </div>
            <RadioBox value={payType === item.payType} />
          </div>
        );
      })}
      <div className="pb-50"></div>

      <div className="pos-f bg-white pb-15" style={{ bottom: 0, left: 20, right: 20 }}>
        <div
          className={`mt-0 text-color-white bg-line-origin-red border-radius-40 p-10 text-center ${
            main?.ispreview ? 'no-click' : ''
          } ${submitFlag ? 'bg-line-origin-grey' : ''}`}
          onClick={handleRecharge}
        >
          立即支付￥{modelParsePrice(preMoney?.amount ?? 0).toFixed(2)}
        </div>
      </div>
    </Page>
  );
}
